import { Pipe, PipeTransform } from '@angular/core';

import { getSecondsInDays } from '../../utils';

@Pipe({
  name: 'rtSecondsInDays',
})
export class SecondsInDaysPipe implements PipeTransform {
  public transform(value: number): number {
    return getSecondsInDays(value);
  }
}
